const moveTitleOnMob = () => {
    const quote = document.querySelector( '.wp-block-drsblocks-quote' )
    if ( !quote ) return
    const singlePost = document.querySelector( '.single-post' )
    const mql = window.matchMedia( '(min-width: 768px)' )
    if ( !mql.matches || singlePost ) {
        const title = quote.querySelector( '.wp-block-drsblocks-quote__title' )
        const cloneTitle = title.cloneNode( true )
        title.remove()
        quote.appendChild( cloneTitle )
    }
}

document.addEventListener( 'DOMContentLoaded', moveTitleOnMob )